import env from "@/lib/env";

declare global {
  interface Window {
    __HR_SHAKTI_VERSION__: Record<string, string>;
  }
}

export function getReleaseVersion(): string {
  return process.env.NEXT_PUBLIC_APP_VERSION ?? "0.1.0";
}

export function getEnvironment(): string {
  return env.NODE_ENV;
}

export function getBuildId(): string {
  return process.env.NEXT_BUILD_ID ?? "unknown";
}

export function getDeploymentRegion(): string {
  return process.env.NEXT_PUBLIC_DEPLOYMENT_REGION ?? "unknown";
}

export function getCommitSha(): string {
  return process.env.NEXT_PUBLIC_COMMIT_SHA ?? "unknown";
}

export function getGitBranch(): string {
  return process.env.NEXT_PUBLIC_GIT_BRANCH ?? "unknown";
}

export function getVersionInfo(): Record<string, string> {
  return {
    version: getReleaseVersion(),
    environment: getEnvironment(),
    buildId: getBuildId(),
    region: getDeploymentRegion(),
    commitSha: getCommitSha(),
    branch: getGitBranch(),
    appName: "HRShakti",
  };
}

export function initReleaseTracking(): void {
  if (typeof window === "undefined") return;

  const versionInfo = getVersionInfo();
  window.__HR_SHAKTI_VERSION__ = versionInfo;

  if (process.env.NODE_ENV === "production") {
    console.info(
      `[HRShakti] v${versionInfo.version} — ${versionInfo.environment} — ${versionInfo.commitSha}`
    );
  }
}